import { render, staticRenderFns } from "./DxEffort.vue?vue&type=template&id=42fd394e&scoped=true&"
import script from "./DxEffort.vue?vue&type=script&lang=js&"
export * from "./DxEffort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fd394e",
  null
  
)

export default component.exports